import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function Google(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#4285F4" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        clipRule="evenodd"
        d="M12.0843 10.993V13.4587C12.0843 13.4587 14.4218 13.4555 15.3736 13.4555C14.8582 15.0539 14.0568 15.9244 12.0843 15.9244C10.0881 15.9244 8.53009 14.2685 8.53009 12.2258C8.53009 10.1832 10.0881 8.52732 12.0843 8.52732C13.1397 8.52732 13.8213 8.90691 14.4465 9.43598C14.947 8.92386 14.9052 8.85088 16.1785 7.62044C15.0976 6.61371 13.661 6 12.0843 6C8.72401 6 6 8.78739 6 12.2258C6 15.6642 8.72401 18.4517 12.0843 18.4517C17.1069 18.4517 18.3346 13.9765 17.9276 10.993C16.7386 10.993 12.0843 10.993 12.0843 10.993Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}

Google.propTypes = propTypes;
Google.defaultProps = defaultProps;

export default Google;
